<template>
    <div>
        <TopBanner />
        <Article />
    </div>
</template>

<script>
import Article from '../components/blogDetailComponents/Article'
import TopBanner from '../components/blogComponents/TopBanner'
export default {
    components: {
        Article,
        TopBanner
    }
  
}
</script>